var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "var(--icon-stroke-width, 1.5)",
    d: "M8 5.286V3m0 10v-2.286M10.714 8H13M3 8h2.286m4.633-1.92 1.617-1.615m-7.072 7.07L6.08 9.92m3.84 0 1.616 1.616m-7.072-7.07L6.08 6.08"
  })));
};
export default SvgLoader;